/// <reference path="_references.js" />

if (isNullOrUndefined(veritracks)) {
    alert('veritracks must be defined before loading localization.');
}

if (isNullOrUndefined(veritracks.localization)) {
    veritracks.localization = {};
}

veritracks.localization.phraseBuilder = function (aBase, aValue) {
    "use strict";
    var lValue = '';

    if (aValue) {
        lValue = aValue;
    }

    return "c" + aBase + lValue.replace(/[^a-zA-Z#0-9]/g, '');
};

veritracks.localization.getPhrase = function (aPhraseName) {
    "use strict";
    var lPhrase = getDataItem(aPhraseName + '.', 'Translation');
    //if (!lPhrase && ObjectLength(getDataItems('Translation')) > 0) {
    //    if (aPhraseName)
    //        gUniversalLocaleMissing[aPhraseName] = $('.' + aPhraseName).html();
    //}
    return lPhrase;
};

veritracks.localization.getPhraseValue = function (aPhraseName) {
    "use strict";
    var lPhrase = veritracks.localization.getPhrase(aPhraseName);
    var lValue;
    if (!isNullOrUndefined(lPhrase))
        lValue = lPhrase.Value
    return lValue;
};

veritracks.localization.localizeTitle = function (aBaseSelector) {
    "use strict";
    var lBaseSelector = '';

    if (aBaseSelector) {
        lBaseSelector = aBaseSelector + ' ';
    }

    function localizeTitle(aId, aElement) {
        aElement.title = localizeTitleFormatter(aElement.title);
    }

    $(lBaseSelector + '[title]').not('.IgnoreTitle').each(localizeTitle);
}
veritracks.localization.localize = function (aBaseSelector) {
    "use strict";
    var lTranslations = getDataItems('Translation'),
        lBaseElement,
        lLocalizable;

    function localizeText(aElement, aPhrase) {
        aElement.innerText = aPhrase.Value;
    }

    function localizeDropdown(aElement, aPhraseName) {
        var lPhrase;
        $(aElement).find('option').each(function (aIndex, aOption) {
            lPhrase = veritracks.localization.getPhrase(aPhraseName + aOption.value);
            if (!isNullOrUndefined(lPhrase)) {
                localizeText(aOption, lPhrase);
            }
        });
    }

    function localizeList(aElement, aPhraseName) {
        var lPhrase = '';
        $(aElement).find('input').each(function (aIndex, aInput) {
            lPhrase = veritracks.localization.getPhrase(aPhraseName + aInput.value);
            if (!isNullOrUndefined(lPhrase)) {
                $(aElement).find("label[for='" + aInput.id + "']").each(function (aIndex, aLabel) {
                    localizeText(aLabel, lPhrase);
                });
            }
        });
    }

    if (!isNullOrUndefined(lTranslations) && count(lTranslations) > 0) {
        lBaseElement = $(aBaseSelector);
        lLocalizable = lBaseElement.find('.cLocalize');

        lLocalizable.each(function (aIndex, aElement) {
            var lPhrase,
                lClass,
                lKey;

            for (lKey in aElement.classList) {
                if (aElement.classList.hasOwnProperty(lKey)) {
                    lClass = aElement.classList[lKey];
                    if (lClass[0] === 'c' && lClass !== 'cLocalize') {
                        lPhrase = veritracks.localization.getPhrase(lClass);
                        if (!isNullOrUndefined(lPhrase)) {
                            localizeText(aElement, lPhrase);
                        } else {
                            if (aElement.tagName.toLowerCase() === 'select') {
                                localizeDropdown(aElement, lClass);
                            } else {
                                localizeList(aElement, lClass);
                            }
                        }
                        $(aElement).removeClass('cLocalize');
                        break;
                    }
                }
            }
        });
    }
};





// USED FOR PERFORMANCE PAGE
function mStateManagerLocalization_Init(aPrevious, aCurrent) {
    "use strict";
    function complete() {
        var l = '';
    }

    populateElement('uMasterContentHolder', 'Localization.Performance.htm', complete);
}

function localizationTest_OnClick() {
    var lStart = new Date(),
        lEnd,
        lTime;
    veritracks.localization.localize('#uBasePerformanceTestElement');
    lEnd = new Date();
    lTime = lEnd - lStart;
    $('#uLocalizationResult').text(lTime.toString() + 'ms');
}